import { getFirebaseIdToken } from '../api/firebase-session';

/**
 * Legacy per-request entry point, kept as a fallback for the many ad-hoc call
 * sites. It now delegates to the global Firebase session: when the user is
 * already signed in (useFirebaseSession) it just returns a fresh ID token;
 * otherwise it performs the old lazy custom-token sign-in.
 */
export const useFirebaseAuth = () => {
  const firebaseAuth = async ({
    email,
    phone,
    userId,
  }: {
    email?: string;
    phone?: string;
    userId: string;
  }): Promise<string | null> => {
    return getFirebaseIdToken({ email, phone, userId });
  };

  return {
    firebaseAuth,
  };
};
